var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('time',{staticClass:"hidden",attrs:{"datetime":_vm.dateTime}},[_vm._v("\n  "+_vm._s(_vm.dateTime)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }